import React from 'react';

const OneColumnContent = ({ children }) => {
  return (
    <div className="one-column-content">
      {children}
    </div>
  );
};

export default OneColumnContent;
